import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { GraduationCap, Award, Trophy } from 'lucide-react';

const EducationCertifications = ({ data }) => {
  return (
    <section id="education" className="py-24 bg-[#0a0a0a] border-t border-[#2a2a2a]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Education */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Education</h2>
          </div>
          
          {data.education.map((edu, index) => (
            <Card key={index} className="bg-[#161616] border-[#2a2a2a] p-8 hover:border-white transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="bg-white text-black p-3 rounded-lg">
                  <GraduationCap className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2">{edu.degree}</h3>
                  <p className="text-[#a3a3a3] text-lg mb-2">{edu.institution}</p>
                  <p className="text-[#666666] text-sm">{edu.details}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Certifications */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Certifications</h2>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6">
            {data.certifications.map((cert, index) => (
              <Card key={index} className="bg-[#161616] border-[#2a2a2a] p-6 hover:border-white transition-all duration-300">
                <div className="flex items-start gap-3">
                  <div className="bg-white text-black p-2 rounded-lg">
                    <Award className="h-5 w-5" />
                  </div>
                  <div className="flex-1">
                    <h4 className="text-white font-semibold mb-2">{cert.title}</h4>
                    <div className="flex items-center gap-2">
                      <p className="text-[#a3a3a3] text-sm">{cert.issuer}</p>
                      <span className="text-[#666666]">•</span>
                      <Badge className="bg-green-500/10 text-green-500 border-green-500/20 text-xs">
                        {cert.status}
                      </Badge>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Awards */}
        <div>
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Awards & Honors</h2>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6">
            {data.awards.map((award, index) => (
              <Card key={index} className="bg-[#161616] border-[#2a2a2a] p-8 hover:border-white transition-all duration-300">
                <div className="flex items-start gap-4">
                  <div className="bg-white text-black p-3 rounded-lg">
                    <Trophy className="h-6 w-6" />
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-white mb-2">{award.title}</h4>
                    <div className="flex items-center gap-2">
                      <p className="text-[#a3a3a3]">{award.organization}</p>
                      <span className="text-[#666666]">•</span>
                      <p className="text-[#666666]">{award.year}</p>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationCertifications;
